module.exports = __webpack_public_path__ + "static/media/general-icons.3f758206f8b3b8dfdf41477204d6f58e69cd742aa40768a791bff2555b968f47.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/core/icons/general-icons.ttf
// module id = 2363
// module chunks = 204